import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form } from 'react-bootstrap';

const LlamadaAccionEditable = ({
    publicacion,
    llamadaAccion,
    catalogoLlamadasAccion,
    estaEditando,
    estaActualizando,
    nuevoValor,
    setNuevoValor,
    onIniciarEdicion,
    onCancelarEdicion,
    onGuardar,
    isDark
}) => {
    return (
        <div style={{
            backgroundColor: isDark ? '#1e3a5f' : '#e7f3ff',
            borderRadius: '8px',
            padding: '12px 16px',
            border: `2px solid ${isDark ? '#2c5282' : '#b3d9ff'}`,
            height: '100%'
        }}>
            {!estaEditando ? (
                <div className="d-flex align-items-center gap-2">
                    <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '6px',
                        backgroundColor: '#0d6efd',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}>
                        <FontAwesomeIcon icon="bullhorn" style={{ color: 'white', fontSize: '1rem' }} />
                    </div>
                    <div className="flex-grow-1">
                        <small className="d-block mb-1" style={{
                            fontSize: '0.7rem',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            color: isDark ? '#8cb3d9' : '#0056b3'
                        }}>
                            Llamada de Acci&oacute;n (CTA)
                        </small>
                        <p className="mb-0 fw-bold" style={{
                            fontSize: '1rem',
                            color: isDark ? '#e9ecef' : '#0d6efd'
                        }}>
                            {llamadaAccion}
                        </p>
                    </div>
                    <Button
                        size="sm"
                        variant="link"
                        className="p-1"
                        onClick={() => onIniciarEdicion(publicacion)}
                        disabled={estaActualizando}
                        style={{ 
                            color: isDark ? '#8cb3d9' : '#0056b3',
                            minWidth: 'auto'
                        }}
                        title="Editar llamada de acción"
                    >
                        <FontAwesomeIcon icon="pencil-alt" style={{ fontSize: '0.9rem' }} />
                    </Button>
                </div>
            ) : (
                <div>
                    <small className="d-block mb-2" style={{
                        fontSize: '0.7rem',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        color: isDark ? '#8cb3d9' : '#0056b3'
                    }}>
                        Llamada de Acci&oacute;n (CTA)
                    </small>
                    <Form.Group>
                        <div className="d-flex gap-2">
                            <Form.Select
                                size="sm"
                                value={nuevoValor}
                                onChange={(e) => setNuevoValor(e.target.value)}
                                disabled={estaActualizando}
                                style={{ borderRadius: '6px', fontSize: '0.85rem' }}
                            >
                                <option value="">Seleccione CTA</option>
                                {catalogoLlamadasAccion.map(llamada => (
                                    <option 
                                        key={llamada.idCatLlamadaAccion} 
                                        value={llamada.idCatLlamadaAccion}
                                    >
                                        {llamada.vNombreLlamadaAccion}
                                    </option>
                                ))}
                            </Form.Select>
                            <Button
                                size="sm"
                                variant="success"
                                onClick={() => onGuardar(publicacion)}
                                disabled={estaActualizando || !nuevoValor}
                                style={{ borderRadius: '6px', minWidth: '38px' }}
                            >
                                {estaActualizando ? (
                                    <span className="spinner-border spinner-border-sm" />
                                ) : (
                                    <FontAwesomeIcon icon="check" />
                                )}
                            </Button>
                            <Button
                                size="sm"
                                variant="secondary"
                                onClick={onCancelarEdicion}
                                disabled={estaActualizando}
                                style={{ borderRadius: '6px', minWidth: '38px' }}
                            >
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </div>
                    </Form.Group>
                </div>
            )}
        </div>
    );
};

LlamadaAccionEditable.propTypes = {
    publicacion: PropTypes.object.isRequired,
    llamadaAccion: PropTypes.string.isRequired,
    catalogoLlamadasAccion: PropTypes.array.isRequired,
    estaEditando: PropTypes.bool.isRequired,
    estaActualizando: PropTypes.bool.isRequired,
    nuevoValor: PropTypes.string.isRequired,
    setNuevoValor: PropTypes.func.isRequired,
    onIniciarEdicion: PropTypes.func.isRequired,
    onCancelarEdicion: PropTypes.func.isRequired,
    onGuardar: PropTypes.func.isRequired,
    isDark: PropTypes.bool.isRequired
};

export default LlamadaAccionEditable;
